import { useState, useCallback } from "react";
import SEO from "@components/SEO";
import FloorFilter from "@components/FloorFilter/FloorFilter";
import BedroomModal from "./components/BedroomModal";
import InfoPopup from "./components/InfoPopup";
import images from "@assets/images";
import { LAYOUT_GROUPS } from "./constants/floors";
import { FLOOR_LAYOUTS } from "./constants/floorLayouts";
import "./MatBangPage.css";

function MatBangPage() {
  const [selectedLayout, setSelectedLayout] = useState("3-7");
  const [hoveredApt, setHoveredApt] = useState(null);
  const [modalApt, setModalApt] = useState(null);

  const handleLayoutChange = (layoutId) => {
    setSelectedLayout(layoutId);
    setHoveredApt(null);
    setModalApt(null);
  };

  const activeGroup =
    LAYOUT_GROUPS.find((g) => g.id === selectedLayout) || LAYOUT_GROUPS[0];

  const currentLayout = FLOOR_LAYOUTS[selectedLayout] || {};

  const planImageMap = {
    "3-7": images.plan3_7,
    "8-12A": images.plan8_12A,
    "14-21": images.plan14_21,
    22: images.plan22,
  };
  const currentPlanImage = planImageMap[selectedLayout] || images.plan;

  const apartments = Object.entries(currentLayout).map(([key, value]) => {
    const [block] = key.split("-");
    return {
      maCan: key,
      block,
      timTuong: value.timTuong,
      thongThuy: value.thongThuy,
      svgPath: value.svgPath,
      bedroomType: value.bedroomType ?? "1PN+",
    };
  });

  const handleAptClick = useCallback((e, apt) => {
    e.stopPropagation();
    setModalApt(apt);
  }, []);

  const handleMouseEnter = useCallback((_, apt) => setHoveredApt(apt), []);
  const handleMouseLeave = useCallback(() => setHoveredApt(null), []);

  return (
    <main className="matbang-page">
      <SEO
        title="Mặt Bằng"
        description="Xem mặt bằng chi tiết từng tầng căn hộ dự án Fenica."
      />

      <FloorFilter
        floors={LAYOUT_GROUPS}
        activeFloor={selectedLayout}
        onFloorChange={handleLayoutChange}
      />

      <div className="matbang-container">
        <div className="matbang-title-overlay">
          <span className="matbang-title-sub">MẶT BẰNG</span>
          <h1 className="matbang-title-main">{activeGroup.label}</h1>
        </div>

        <div className="matbang-viewport">
          <img
            key={currentPlanImage}
            src={currentPlanImage}
            alt="Mặt bằng Fenica"
            className="matbang-bg-img"
          />
          <svg
            className={`matbang-svg-overlay${hoveredApt ? " matbang-svg-overlay--has-active" : ""}`}
            viewBox="0 0 5000 2500"
          >
            {apartments.map((apt) => (
              <path
                key={apt.maCan}
                d={apt.svgPath}
                pathLength="100"
                className={`matbang-path-unit${hoveredApt?.maCan === apt.maCan ? " matbang-path-unit--active" : ""}`}
                onMouseEnter={(e) => handleMouseEnter(e, apt)}
                onMouseLeave={handleMouseLeave}
                onClick={(e) => handleAptClick(e, apt)}
              />
            ))}
          </svg>

          {hoveredApt && (
            <div className="matbang-popup-wrapper">
              <InfoPopup
                title="Căn hộ"
                type={hoveredApt.maCan}
                specs={[
                  {
                    label: "Diện tích tim tường",
                    value: `${hoveredApt.timTuong}m²`,
                  },
                  {
                    label: "Diện tích thông thủy",
                    value: `${hoveredApt.thongThuy}m²`,
                  },
                  {
                    label: "Tháp",
                    value: hoveredApt.block === "A" ? "Tháp A" : "Tháp B",
                  },
                ]}
              />
            </div>
          )}
        </div>
      </div>

      <p className="matbang-hint">Nhấn vào căn để xem chi tiết</p>

      <BedroomModal apt={modalApt} onClose={() => setModalApt(null)} />
    </main>
  );
}

export default MatBangPage;
